import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({
  selector: 'app-operation-modal',
  templateUrl: './operation-modal.component.html',
  styleUrls: ['./operation-modal.component.css']
})

export class OperationModalComponent {
  @Input() car: any;
  @Input() acssess: any;
  @Input() carId: number = 0;

  tanker_Calibration = false;
  weight_Calibration = false;

  mdl_Calibration: FormGroup;

  constructor(
    private router: Router,
    private notifyService: NotificationService,
    public otherService: OtherService,
    private gurdService: GurdServiceService,
    private formBuilder: FormBuilder
  ) {
    this.mdl_Calibration = this.formBuilder.group({
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      tiStatus: new FormControl('0'),
      tiType: new FormControl('1'),
      iFule: new FormControl('', Validators.required),
      strUnitID: new FormControl('', Validators.required),
    });
  }

  ngOnChanges(): void {
    if (this.carId) {
      this.mdl_Calibration.patchValue({ strUnitID: this.carId });
    }
  }

  open(): void {
    $('#Operation_Modal').modal('show');
  }

  hide(): void {
    $('#Operation_Modal').modal('hide');
  }

  goToTempAccess(): void {
    this.hide();
    this.router.navigate(['tempAccess'], { queryParams: { id: this.carId } });
  }

  open_Calibration(bTanker: boolean = false, bWeightSensor: boolean = false): void {
    this.tanker_Calibration = bTanker;
    this.weight_Calibration = bWeightSensor;
    this.mdl_Calibration.patchValue({
      tiStatus: 0,
      iFule: '',
      strUnitID: this.carId
    });
    this.hide();
    // small delay to avoid backdrop conflict
    setTimeout(() => $('#calibration_Modal').modal('show'), 300);
  }

  async submit_Calibration(): Promise<void> {
    const model: any = this.otherService.stringNumberToNumber(this.mdl_Calibration.value);
    model.tiType = this.tanker_Calibration ? 2 : 1;
    model.tiType = this.weight_Calibration ? 3 : model.tiType;

    if (model.iFule == '' || model.iFule == 0) {
      return this.notifyService.showError('مقدار سوخت موجود در باک را وارد کنید!');
    }

    this.otherService.Showspinner();
    const resp = await axios.post(`FuelSensor_FuelQuantity_Save`, model);
    this.otherService.nonespinner();
    const res = JSON.parse(resp.data);

    if (res.iResult == 1) {
      $('#calibration_Modal').modal('hide');
      return this.notifyService.showSuccess(res.strError);
    }
    if (res.iResult == 0) {
      $('#calibration_Modal').modal('hide');
      return this.notifyService.showError(res.strError);
    }
  }
}
